import Store from 'app/redux/store'
import Redux from 'app/interface/redux'
import { bindActions } from 'redux-zero/utils'
import { BusinessPublic } from '@marketing-milk/interfaces'
import { NestAPI } from '../../../../nestapi'

const Master = bindActions(
  store => ({
    init: async (): Promise<void> => {
      const result: BusinessPublic[] = await NestAPI.get('businesses/names')
      const state: Redux = store.getState()
      store.setState({
        data: {
          ...state.data,
          generic: {
            ...state.data.generic,
            businesses: {
              data: result,
              loading: false,
              timestamp: +new Date(),
            },
          },
        },
      })
    },
  }),
  Store
)

export default Master
